import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../libs'
import {
  TransactionRequest,
  TransactionResponse,
} from '../transactions/list/types'

export type TransactionOption = {
  value: string
  label: string
  currency: string
  clientAmount: string
  clientCurrency: string
}

export const transactionsSearched = createEvent<string>()

export const getTransactions = fx<TransactionRequest, TransactionResponse>({
  method: 'GET',
  url: `/transaction_request`,
})

export const $transactionOptions = restore<TransactionOption[]>(
  getTransactions.doneData.map((a) =>
    a.body.items.map((transaction) => {
      const context = [
        transaction.client?.email,
        [transaction.initialAmount, transaction.initialCurrency]
          .filter(Boolean)
          .join(' '),
      ]
        .filter(Boolean)
        .join(', ')

      const value = String(transaction.transactionId)

      return {
        value,
        label: context ? `${value} — ${context}` : value,
        currency: transaction.initialCurrency,
        clientAmount: transaction.clientAmount,
        clientCurrency: transaction.clientCurrency,
      }
    }),
  ),
  [],
)

sample({
  clock: transactionsSearched,
  fn: (search) => {
    const query: Record<string, string> = {
      limit: '20',
      order: '-id',
    }

    if (search.trim() !== '') {
      query.where = JSON.stringify({ id: search.trim() })
    }

    return { query }
  },
  target: getTransactions,
})
